export default __webpack_public_path__ + "static/media/clouds.0ed0bf19.svg";